import Typography from "../Typography";

const Loading = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography size="h4">Loading...</Typography>
    </div>
  );
};

export default Loading;
